// @flow
import { connect } from "react-redux";

import { login } from "../actions/SignIn";

import { getApplication } from "../_modularui/ModularUISelectors";

import type { ReduxState, ThunkAction } from "../types";
import type { ComponentType } from "react";

type StateProps = {
  isAuthenticated: boolean,
  errorMessage: ?string,
};

type DispatchProps = {
  onSubmit: (username: string, password: string) => ThunkAction<>,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
};

const mapStateToProps = (state: ReduxState): StateProps => {
  const application = getApplication(state);

  return {
    isAuthenticated: application?.isLoggedIn ?? false,
    errorMessage: state.auth.error,
  };
};

const mapDispatchToProps: DispatchProps = {
  onSubmit: login,
};

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useLogin' instead
 */
export const connectSignIn: ComponentType<any> = connect<
  Props,
  {},
  StateProps,
  _,
  _,
  _,
>(mapStateToProps, mapDispatchToProps);
